// extracted by mini-css-extract-plugin
module.exports = {"container":"MSelectFilter_container__1Axu2"};